<i class="mdi mdi-{{this.mdiIcon()}}"
   [title]="this.tooltip()"
></i>

